import type { FaireThemeEntity } from "../../entity_types/theme";

export const athleisure_lounge_refresh: FaireThemeEntity = {
  token: "athleisure-lounge-refresh",
  type: "theme",
  name: "Athleisure & Lounge Refresh",
  description: "Reliable category that drives repeat purchases and easy outfit building -- boutique clothing that sells year-round in your brick-and-mortar",
  teaser: "",
  detail: "",
  bgColor: "#F5D6D6",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ansnpw9cjc",
    "p_e2p8ap6u37",
    "p_g7qncrpqan",
    "p_wuse5vsqch",
    "p_y6gyryaxdg",
    "p_e4u7angchp",
    "p_tccpz3grx9",
    "p_kbbmnfdbcm",
    "p_6bcx89d8v2",
    "p_ck8rjyz37h",
    "p_3kdrf453d8",
    "p_sqk8xrhr75",
    "p_uwt9nktqjm",
    "p_5amvsuzhck",
    "p_3bu7pwuqmw",
    "p_scn3uh45q4",
    "p_n9vgmnxhvj",
    "p_3ua2hkh2rd",
    "p_d3ama7c5rm",
    "p_tferhq96xn",
    "p_vmtr5mjmhj",
    "p_gdk644d9mm",
    "p_um4pnzf3ku",
    "p_nkudmq7x6t",
    "p_7p4hfz5jhs",
    "p_9awkju38d9",
    "p_2q878h29b7",
    "p_ymvueshsp3",
    "p_4x7qbqtdxc",
    "p_7dsvu83hpc",
    "p_yd4tj6njxd",
    "p_jkz6er794p",
    "p_ecnqa5pmhr",
    "p_8dmzgaqaaa",
    "p_5t6xu2g478",
    "p_2r5hkbvw9h",
    "p_ythjreg8d4",
    "p_xdw889ctrr",
    "p_8xwdtsrxhr",
    "p_gqcrwe7za2",
    "p_vadrzb5u7v",
    "p_bt74uv2sv6",
    "p_f3px9mb2kv",
    "p_5z66yk9pfr",
    "p_tgrmr99575",
    "p_yscejvfrrx",
    "p_da5mrmvnse",
    "p_smzyrbb2y2",
    "p_h42ckgd37y",
    "p_4xgw53ydbe",
    "p_jra53kwdw9",
    "p_2w6bhbxt97",
    "p_3j1eal625j",
    "p_hv7a9g8psq",
    "p_qc46thy234",
    "p_rgfk38cn85",
    "p_6ku555n2wa",
    "p_6rbx3jcxxz",
    "p_aejju8jhqm",
    "p_s6csnqba9q",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
